export default __webpack_public_path__ + "static/media/orca.f012a581.jpg";